/* import __COLOCATED_TEMPLATE__ from './plan-card-badge.hbs'; */
/* RESPONSIBLE TEAM: team-purchase */
import Component from '@glimmer/component';

interface Args {
  style: 'grey' | 'black' | 'paywall';
  text: string;
}

export default class PlanCardBadgeComponent extends Component<Args> {
  get textClass(): string {
    switch (this.args.style) {
      case 'grey':
        return 'text-default';
      case 'black':
        return 'text-on-neutral';
      case 'paywall':
        return 'text-default';
    }
  }

  get backgroundClass(): string {
    switch (this.args.style) {
      case 'grey':
        return 'bg-neutral-container';
      case 'black':
        return 'bg-neutral-fill';
      case 'paywall':
        return 'bg-paywall-container';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Paywalls::Comparison::PlanCardBadge': typeof PlanCardBadgeComponent;
    'paywalls/comparison/plan-card-badge': typeof PlanCardBadgeComponent;
  }
}
